(function(){
  var root = document.querySelector('.cpcg');
  if (!root) return;
  var cfgEl = document.getElementById('cpcg-data');
  if (!cfgEl) return;
  var CFG = JSON.parse(cfgEl.textContent);

  var CDN = "https://cdn.ssactivewear.com/Images/Color/";
  var COLORWAYS_URL = "https://cdn.shopify.com/s/files/1/1039/5392/4379/files/cpc-colorways.json?v=1785837561";
  var handle = CFG.handle;
  var isHat = CFG.isHat;
  var VARIANTS = CFG.variants;
  var LOCS = CFG.locs;
  var TIERS = ["1-5","6-11","12-23","24-47","48-99"];

  var PRESETS = { 'Full Front': {x:30,y:24,w:40}, 'Left Chest': {x:55,y:26,w:14}, 'Hat': {x:36,y:28,w:28} };
  var box = isHat ? {x:36,y:28,w:28} : {x:30,y:24,w:40};

  var state = {color:null, loc:LOCS[0], place:'Full Front', qty:0, sizes:{}};
  var data = null;

  var el = {
    stage: document.getElementById('cpcg-stage'),
    blank: document.getElementById('cpcg-blank'),
    blankField: document.getElementById('cpcg-blank-field'),
    swatches: document.getElementById('cpcg-swatches'),
    colorName: document.getElementById('cpcg-color-name'),
    colorField: document.getElementById('cpcg-color-field'),
    photo: document.getElementById('cpcg-photo'),
    overlay: document.getElementById('cpcg-overlay'),
    handle: document.getElementById('cpcg-handle'),
    hint: document.getElementById('cpcg-hint'),
    thumbs: document.getElementById('cpcg-thumbs'),
    sizes: document.getElementById('cpcg-sizes'),
    sizesField: document.getElementById('cpcg-sizes-field'),
    qty: document.getElementById('cpcg-qty'),
    qtyField: document.getElementById('cpcg-qty-field'),
    price: document.getElementById('cpcg-price'),
    variant: document.getElementById('cpcg-variant'),
    add: document.getElementById('cpcg-add'),
    quote: document.getElementById('cpcg-quote'),
    posField: document.getElementById('cpcg-pos-field'),
    placeField: document.getElementById('cpcg-place-field'),
    mockInput: document.getElementById('cpcg-mockup-file'),
    form: document.getElementById('cpcg-form')
  };

  function initData(d){
    data = d;
    if (!data) return;
    el.blank.textContent = data.blank;
    el.blankField.value = data.blank;
    buildSwatches();
    buildSizes();
    refresh();
  }

  function buildSwatches(){
    var frag = document.createDocumentFragment();
    data.colors.forEach(function(c, i){
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'cpcg__sw'; b.title = c.n;
      if (c.img) { b.style.backgroundImage = 'url(' + CDN + c.img + ')'; }
      else if (c.hex) { b.style.background = (c.hex.charAt(0) === '#' ? c.hex : '#' + c.hex); }
      b.addEventListener('click', function(){ pickColor(c, b); });
      frag.appendChild(b);
      if (i === 0) { setTimeout(function(){ pickColor(c, b); }, 0); }
    });
    el.swatches.appendChild(frag);
  }

  function pickColor(c, btn){
    state.color = c.n;
    var all = el.swatches.querySelectorAll('.cpcg__sw');
    for (var i = 0; i < all.length; i++) all[i].classList.remove('is-active');
    if (btn) btn.classList.add('is-active');
    el.colorName.textContent = c.n;
    el.colorField.value = c.n;
    if (c.img) { el.photo.crossOrigin = 'anonymous'; el.photo.decoding = 'async'; el.photo.src = CDN + c.img; }
  }

  var SIZE_ORDER = ['XS','S','M','L','XL','2XL','3XL','4XL','5XL','M/L','Adjustable','One Size'];
  function sortedSizes(){ return data.sizes.slice().sort(function(a,b){ return SIZE_ORDER.indexOf(a) - SIZE_ORDER.indexOf(b); }); }

  function buildSizes(){
    var frag = document.createDocumentFragment();
    sortedSizes().forEach(function(s){
      var d = document.createElement('div'); d.className = 'cpcg__size';
      var l = document.createElement('label'); l.textContent = s;
      var inp = document.createElement('input');
      inp.type = 'number'; inp.min = 0; inp.inputMode = 'numeric'; inp.placeholder = '0';
      inp.addEventListener('input', function(){ state.sizes[s] = parseInt(inp.value,10) || 0; refresh(); });
      d.appendChild(l); d.appendChild(inp); frag.appendChild(d);
    });
    el.sizes.appendChild(frag);
  }

  var locBtns = root.querySelectorAll('.cpcg__loc[data-loc]');
  for (var i = 0; i < locBtns.length; i++) {
    (function(b){
      b.addEventListener('click', function(){
        state.loc = b.getAttribute('data-loc');
        for (var j = 0; j < locBtns.length; j++) locBtns[j].classList.remove('is-active');
        b.classList.add('is-active');
        refresh();
      });
    })(locBtns[i]);
  }

  var placeBtns = root.querySelectorAll('.cpcg__place');
  for (var k = 0; k < placeBtns.length; k++) {
    (function(b){
      b.addEventListener('click', function(){
        state.place = b.getAttribute('data-place');
        for (var j = 0; j < placeBtns.length; j++) placeBtns[j].classList.remove('is-active');
        b.classList.add('is-active');
        if (el.placeField) el.placeField.value = state.place;
        var p = PRESETS[state.place];
        if (p) { box = {x:p.x, y:p.y, w:p.w}; applyBox(); }
      });
    })(placeBtns[k]);
  }

  function applyBox(){
    var o = el.overlay;
    o.style.left = box.x + '%';
    o.style.top = box.y + '%';
    o.style.width = box.w + '%';
    o.style.height = 'auto';
    if (el.posField) el.posField.value = state.place + ' | x ' + Math.round(box.x) + '%, y ' + Math.round(box.y) + '%, width ' + Math.round(box.w) + '% of preview';
  }
  function clampBox(){
    box.w = Math.min(92, Math.max(8, box.w));
    box.x = Math.min(100 - box.w, Math.max(0, box.x));
    box.y = Math.min(90, Math.max(0, box.y));
  }

  (function wireDrag(){
    var o = el.overlay, h = el.handle, st = el.stage;
    if (!o || !st) return;
    var start = null;
    o.addEventListener('pointerdown', function(e){
      if (e.target === h) return;
      e.preventDefault();
      try { o.setPointerCapture(e.pointerId); } catch(x){}
      var r = st.getBoundingClientRect();
      start = {px:e.clientX, py:e.clientY, bx:box.x, by:box.y, rw:r.width, rh:r.height};
    });
    o.addEventListener('pointermove', function(e){
      if (!start) return;
      box.x = start.bx + ((e.clientX - start.px) / start.rw) * 100;
      box.y = start.by + ((e.clientY - start.py) / start.rh) * 100;
      clampBox(); applyBox();
    });
    o.addEventListener('pointerup', function(){ start = null; });
    o.addEventListener('pointercancel', function(){ start = null; });
    if (h) {
      var rs = null;
      h.addEventListener('pointerdown', function(e){
        e.preventDefault(); e.stopPropagation();
        try { h.setPointerCapture(e.pointerId); } catch(x){}
        var r = st.getBoundingClientRect();
        rs = {px:e.clientX, bw:box.w, rw:r.width};
      });
      h.addEventListener('pointermove', function(e){
        if (!rs) return;
        box.w = rs.bw + ((e.clientX - rs.px) / rs.rw) * 100;
        clampBox(); applyBox();
      });
      h.addEventListener('pointerup', function(){ rs = null; });
      h.addEventListener('pointercancel', function(){ rs = null; });
    }
  })();

  function buildPreview(file, maxPx, done, fail){
    function paint(source, w, h, release){
      try {
        var scale = Math.min(1, maxPx / Math.max(w, h));
        var cw = Math.max(1, Math.round(w * scale));
        var ch = Math.max(1, Math.round(h * scale));
        var c = document.createElement('canvas'); c.width = cw; c.height = ch;
        var ctx = c.getContext('2d');
        ctx.imageSmoothingEnabled = true; ctx.imageSmoothingQuality = 'high';
        ctx.drawImage(source, 0, 0, cw, ch);
        if (release) release();
        done(c);
      } catch (e) { if (release) release(); if (fail) fail(); }
    }
    function viaImage(){
      var url = URL.createObjectURL(file);
      var im = new Image();
      im.onload = function(){ paint(im, im.naturalWidth || maxPx, im.naturalHeight || maxPx, function(){ URL.revokeObjectURL(url); }); };
      im.onerror = function(){ URL.revokeObjectURL(url); if (fail) fail(); };
      im.decoding = 'async'; im.src = url;
    }
    if (window.createImageBitmap) {
      try {
        var p = createImageBitmap(file);
        if (p && p.then) { p.then(function(bm){ paint(bm, bm.width, bm.height, function(){ if (bm.close) bm.close(); }); })['catch'](viaImage); return; }
      } catch (e) {}
    }
    viaImage();
  }

  var PREVIEWABLE = /image\/(png|jpe?g|svg\+xml|webp|gif|bmp)/;

  ['front','back','side'].forEach(function(slot){
    var inp = document.getElementById('cpcg-file-' + slot);
    if (!inp) return;
    inp.addEventListener('change', function(){
      var f = inp.files && inp.files[0];
      var em = document.getElementById('cpcg-fn-' + slot);
      if (!f) return;
      if (f.size > 20 * 1024 * 1024) { em.textContent = 'That file is over 20MB. Choose a smaller version, or email the full file to us after ordering.'; inp.value = ''; return; }
      var mb = f.size / 1048576;
      var sizeLabel = mb < 1 ? Math.round(f.size / 1024) + ' KB' : mb.toFixed(1) + ' MB';
      var isFront = slot === 'front';
      if (!PREVIEWABLE.test(f.type)) { em.textContent = f.name + ' (' + sizeLabel + '). Preview not available for this file type. Your emailed mockup will show it.'; refresh(); return; }
      em.textContent = f.name + ' (' + sizeLabel + '). Building preview.';
      setTimeout(function(){
        buildPreview(f, isFront ? 1400 : 240, function(canvas){
          if (isFront) {
            var old = document.getElementById('cpcg-art');
            if (old) old.parentNode.removeChild(old);
            canvas.id = 'cpcg-art';
            el.overlay.insertBefore(canvas, el.handle);
            el.overlay.hidden = false;
            if (el.handle) el.handle.hidden = false;
            if (el.hint) el.hint.hidden = false;
            applyBox();
          } else {
            var oldT = document.getElementById('cpcg-thumb-' + slot);
            if (oldT) oldT.parentNode.removeChild(oldT);
            canvas.id = 'cpcg-thumb-' + slot;
            canvas.title = slot + ' artwork';
            el.thumbs.appendChild(canvas);
          }
          em.textContent = f.name + ' (' + sizeLabel + ')';
        }, function(){ em.textContent = f.name + ' (' + sizeLabel + '). Preview could not be generated, your file is still attached to the order.'; });
      }, 0);
      refresh();
    });
  });

  // Flatten garment + placed artwork into a PNG the merchant sees on the order.
  // The garment image is fetched over CORS (SS CDN allows it) so the canvas is
  // not tainted; if that fetch fails we still export an art-only mockup, and the
  // raw file + Artwork Position text always travel with the order regardless.
  function exportCanvas(c, done){
    try { c.toBlob(function(b){
      if (!b) { done(false); return; }
      try { var dt = new DataTransfer(); dt.items.add(new File([b], 'customer-mockup.png', {type:'image/png'})); el.mockInput.files = dt.files; done(true); }
      catch(e){ done(false); }
    }, 'image/png'); } catch(e){ done(false); }
  }

  function buildMockup(done){
    var art = document.getElementById('cpcg-art');
    if (!art || el.overlay.hidden || !el.mockInput) { done(false); return; }
    var r = el.stage.getBoundingClientRect();
    var S = 2;
    var c = document.createElement('canvas');
    c.width = Math.round(r.width * S); c.height = Math.round(r.height * S);
    var ctx = c.getContext('2d');
    ctx.fillStyle = '#101010'; ctx.fillRect(0, 0, c.width, c.height);
    var pr = el.photo.getBoundingClientRect();
    var ar = art.getBoundingClientRect();
    var drawArt = function(){ ctx.drawImage(art, (ar.left - r.left) * S, (ar.top - r.top) * S, ar.width * S, ar.height * S); exportCanvas(c, done); };
    var src = el.photo.currentSrc || el.photo.src;
    fetch(src, {mode:'cors'})
      .then(function(res){ return res.blob(); })
      .then(function(blob){ return createImageBitmap(blob); })
      .then(function(bm){ ctx.drawImage(bm, (pr.left - r.left) * S, (pr.top - r.top) * S, pr.width * S, pr.height * S); if (bm.close) bm.close(); drawArt(); })
      ['catch'](function(){ drawArt(); });
  }

  var mockDone = false;
  if (el.form) {
    el.form.addEventListener('submit', function(e){
      if (mockDone) return;
      var art = document.getElementById('cpcg-art');
      if (!art || el.overlay.hidden) return;
      e.preventDefault();
      var fired = false;
      var go = function(){ if (fired) return; fired = true; mockDone = true; el.form.submit(); };
      setTimeout(go, 2000);
      buildMockup(function(){ go(); });
    });
  }

  function tierFor(q){
    if (q < 6) return "1-5";
    if (q < 12) return "6-11";
    if (q < 24) return "12-23";
    if (q < 48) return "24-47";
    if (q < 100) return "48-99";
    return null;
  }

  function refresh(){
    if (!data) return;
    var q = 0;
    for (var key in state.sizes) { if (state.sizes.hasOwnProperty(key)) q += state.sizes[key]; }
    state.qty = q;
    el.qty.textContent = q;
    el.qtyField.value = Math.max(q, 1);

    var parts = [];
    sortedSizes().forEach(function(s){ if (state.sizes[s]) parts.push(s + ' x ' + state.sizes[s]); });
    el.sizesField.value = parts.join(', ');

    var loc = state.loc;
    var backSlot = root.querySelector('[data-slot="back"]');
    var sideSlot = root.querySelector('[data-slot="side"]');
    if (backSlot) backSlot.hidden = loc.indexOf('Back') === -1;
    if (sideSlot) sideSlot.hidden = (loc.indexOf('Sleeve') === -1 && loc.indexOf('Side') === -1);

    TIERS.forEach(function(t){
      var v = VARIANTS[loc + "|" + t];
      var cell = root.querySelector('[data-tier="' + t + '"]');
      if (!cell) return;
      cell.textContent = v ? '$' + v.price : '--';
      cell.classList.remove('is-active');
    });

    if (q >= 100) { el.add.hidden = true; el.quote.hidden = false; el.price.textContent = 'Custom quote'; return; }
    el.add.hidden = false; el.quote.hidden = true;

    var useTier = tierFor(q) || "1-5";
    var v = VARIANTS[loc + "|" + useTier];
    if (v) {
      el.variant.value = v.id;
      el.price.textContent = '$' + v.price;
      var cell = root.querySelector('[data-tier="' + useTier + '"]');
      if (cell) cell.classList.add('is-active');
    }
    el.add.disabled = q < 1;
  }

  // Run last, after every var and helper above is initialized.
  // Prefer the per-product cpc.colorways metafield emitted inline by Liquid.
  // Any product tagged cpc-garment (garments AND corporate blanks) works with
  // no per-blank JS. Falls back to the shared external file for older data.
  if (CFG.colorways) {
    initData(CFG.colorways);
  } else {
    fetch(COLORWAYS_URL).then(function(r){ return r.json(); }).then(function(all){ initData(all[handle]); })['catch'](function(){});
  }
})();
